<template>
  <div row :class="ui.colorNavigationBar">
    <v-layout class="ml-3 mr-3">
      <StatusBarSelection/>
      <v-spacer/>
      <LinkBar/>
      <StatusBarInfo/>
    </v-layout>
  </div>
</template>
<script>
import LinkBar from "@/frame/navigation/components/LinkBar";
import StatusBarSelection from "@/frame/navigation/components/StatusBarSelection";
import StatusBarInfo from "@/frame/navigation/components/StatusBarInfo";
import apptheme from "@/frame/theme/mixins/apptheme.js";
export default {
  components: {
    LinkBar,
    StatusBarSelection,
    StatusBarInfo
  },
  mixins: [apptheme]
};
</script>
